import React from "react";
import { Chip } from "@mui/material";
import {
  adminGetBusinessOfferings, adminCreateBusinessOffering, adminUpdateBusinessOffering,
} from "../../api/business";
import GenericCrudPage from "../../components/shared/GenericCrudPage";

const CATEGORY_OPTIONS = [
  { value: "SERVICE", label: "Service" },
  { value: "BUSINESS", label: "Business" },
];

export default function BusinessOfferingsPage() {
  return (
    <GenericCrudPage
      title="Business Offerings"
      queryKey="admin-business-offerings"
      listFn={adminGetBusinessOfferings}
      createFn={adminCreateBusinessOffering}
      updateFn={adminUpdateBusinessOffering}
      emptyItem={{
        title: "", slug: "", category: "SERVICE",
        short_description: "", detailed_description: "",
        icon_or_image: "", order_index: 0, is_active: true,
        meta_title: "", meta_description: "",
      }}
      columns={[
        { key: "title", label: "Title" },
        { key: "category", label: "Category", render: (r) => <Chip size="small" label={r.category} /> },
        { key: "is_active", label: "Active", render: (r) => (r.is_active ? "Yes" : "No") },
      ]}
      formFields={[
        { name: "title", label: "Title", required: true },
        { name: "slug", label: "Slug (URL-friendly)", required: true },
        { name: "category", label: "Category", type: "select", options: CATEGORY_OPTIONS, required: true },
        { name: "short_description", label: "Short Description", type: "textarea" },
        { name: "detailed_description", label: "Detailed Description", type: "textarea" },
        { name: "icon_or_image", label: "Icon / Image", type: "file" },
        { name: "order_index", label: "Order Index", type: "number" },
        { name: "meta_title", label: "Meta Title" },
        { name: "meta_description", label: "Meta Description", type: "textarea" },
        { name: "is_active", label: "Active", type: "switch" },
      ]}
    />
  );
}